<template>
    <div>
        <div id='travellerSection'>
            <div id='traveller1'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 1 ({{$t("text.applicant")}})</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                          <label for='traveller1_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
              <datepicker id='traveller1_dob' 
                v-model='traveller1_dob'
                :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabled ="isDisabledPrimaryApplicant1"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'>
              </datepicker>
                          <div class='form-row' style=''>
                            <div class='col-auto'>
                              <input @change='swapPrimaryApplicant' type='checkbox' class='regular-checkbox' id='isPrimaryApplicant' name='isNotPrimaryApplicant' style='margin-top:20px;'/>
                            </div>
                            <div class='col'>
                                <label for='isPrimaryApplicant' id='lbl_isPrimaryApplicant' class='checkbox-label' style='color: #666666; margin-top:20px;'>{{$t("text.primaryapplicant")}}</label>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                            <span for='traveller1_dob' class='feedback' id='err_traveller1_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>
 
            <div id='traveller2'>
            <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 2</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                          <label for='traveller2_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
              <datepicker id='traveller2_dob' 
                v-model='traveller2_dob'
                :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabled = "isDisabledPrimaryApplicant2"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>  
                            <div class='form-row' style=''>
                              <div class='col-auto'>
                                <input @change='swapPrimaryApplicant' type='checkbox' class='regular-checkbox' id='isNotPrimaryApplicant' name='isNotPrimaryApplicant' style='margin-top:20px;'/>
                              </div>
                              <div class='col'>
                                  <label for='isNotPrimaryApplicant' id='lbl_isNotPrimaryApplicant' class='checkbox-label' style='color: #666666; margin-top:20px;'>{{$t("text.primaryapplicant")}}</label>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                            <span for='traveller2_dob' class='feedback' id='err_traveller2_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller3'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 3</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller3_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller3_dob' 
                            v-model='traveller3_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller3_dob' class='feedback' id='err_traveller3_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller4'>
                <fieldset>
                <legend class='textTraveller'>{{$t("text.traveller")}} # 4</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller4_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller4_dob' 
                            v-model='traveller4_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller4_dob' class='feedback' id='err_traveller4_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller5'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 5</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller5_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller5_dob' 
                            v-model='traveller5_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller5_dob' class='feedback' id='err_traveller5_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller6'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 6</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller6_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller6_dob' 
                            v-model='traveller6_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller6_dob' class='feedback' id='err_traveller6_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller7'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 7</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller7_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller7_dob' 
                            v-model='traveller7_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller7_dob' class='feedback' id='err_traveller7_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller8'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 8</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller8_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller8_dob' 
                            v-model='traveller8_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller8_dob' class='feedback' id='err_traveller8_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller9'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 9</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller9_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller9_dob' 
                            v-model='traveller9_dob'
                            :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller9_dob' class='feedback' id='err_traveller9_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller10'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 10</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                            <label for='traveller10_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                            <datepicker id='traveller10_dob' 
                                v-model='traveller10_dob'
                                :flow="['year', 'month', 'day']"
                :openDate="openBirthDates"
                :disabledDates="disabledBirthDates" 
                model-type="format"
                :typeable=true
                :auto-apply="true"
                :enable-time-picker="false"
                :text-input="{
                  format: ['MM/dd/yyyy'],
                  tabSubmit: true,
                  openMenu: true
                }"           
                input-class='form-control'
                :placeholder='$t("text.datePlaceholder")'
                :locale="getLocale()"
                :format="'MM/dd/yyyy'"
                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller10_dob' class='feedback' id='err_traveller10_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <br/>
        <div v-show='this.$store.state.oldestTraveller>=60&&this.$store.state.wantsMedical===true'>
            {{$t('text.page4_medicalquestionnaire')}}
        </div>
    </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import { updateNavProceed } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import { validateBirthDate } from "../utils/validation_custom.js";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
const today = new Date();
today.setHours(0, 0, 0, 0);
const birthCutoffDate = new Date(today);
birthCutoffDate.setDate(birthCutoffDate.getDate() - 15);

export default {
  components: {
    Datepicker: VueDatePicker
  },
  data() {
    return {
      disabledBirthDates: (candidateDate) => {
        if (!candidateDate) {
          return false;
        }
        const normalizedDate = new Date(candidateDate);
        normalizedDate.setHours(0, 0, 0, 0);
        return normalizedDate >= birthCutoffDate;
      },
      province_full: this.$store.state.province_full,
      isDisabledPrimaryApplicant1 : true,
      isDisabledPrimaryApplicant2 : false
    }
  },
  computed: {
    openBirthDates: {
        get(){
            const openBirthDate = new Date();
            openBirthDate.setDate(openBirthDate.getDate() - this.$store.state.oldestTraveller * 365);
            return openBirthDate;
        }
    },
    traveller1_dob: {
      get() {
        if(this.$store.state.traveller1_dob==="" && (this.$store.state.oldestTraveller_isPrimary===true||this.$store.state.numberOfTravellers===1)) {
          this.$store.state.traveller1_dob = this.$store.state.oldestTraveller_dob; 
          return this.$store.state.oldestTraveller_dob; 
        }
        else {
          return this.$store.state.traveller1_dob;
        }
      },
      set(newValue) {
        this.setDateOfBirth("traveller1_dob", newValue);
      }
    },
    traveller2_dob: {
      get() {
        if(this.$store.state.traveller2_dob==="" && this.$store.state.oldestTraveller_isPrimary===false) {
          return this.$store.state.oldestTraveller_dob; 
        }
        else {        
          return this.$store.state.traveller2_dob;
        }
      },
      set(newValue) {
        this.setDateOfBirth("traveller2_dob", newValue);
      }
    },
    traveller3_dob: {
      get() {
        return this.$store.state.traveller3_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller3_dob", newValue);
      }
    },
    traveller4_dob: {
      get() {
        return this.$store.state.traveller4_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller4_dob", newValue);
      }
    },
    traveller5_dob: {
      get() {
        return this.$store.state.traveller5_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller5_dob", newValue);
      }
    },
    traveller6_dob: {
      get() {
        return this.$store.state.traveller6_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller6_dob", newValue);
      }
    },
    traveller7_dob: {
      get() {
        return this.$store.state.traveller7_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller7_dob", newValue);
      }
    },
    traveller8_dob: {
      get() {
        return this.$store.state.traveller8_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller8_dob", newValue);
      }
    },
    traveller9_dob: {
      get() {
        return this.$store.state.traveller9_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller9_dob", newValue);
      }
    },
    traveller10_dob: {
      get() {
        return this.$store.state.traveller10_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller10_dob", newValue);
      }
    },
  },
  methods: {
    getLocale,
    normalizeDateInput(value) {
      if (!value) {
        return "";
      }
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return this.$moment(value).format("MM/DD/YYYY");
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) {
          return "";
        }
        const parsed = this.$moment(trimmed, ["MM/DD/YYYY", "M/D/YYYY"], true);
        return parsed.isValid() ? parsed.format("MM/DD/YYYY") : trimmed;
      }
      return "";
    },
    getDatepickerElements(fieldId) {
      const root = document.getElementById(fieldId) || null;
      if (root) {
        root.dataset.travellerDobWrapper = "true";
      }
      const input = root ? root.querySelector("input.dp__input") : null;
      return { root, input };
    },
    getDatepickerValue(fieldId) {
      const { root, input } = this.getDatepickerElements(fieldId);
      if (input && typeof input.value === "string") {
        return input.value;
      }
      if (root && typeof root.value === "string") {
        return root.value;
      }
      return "";
    },
    setDatepickerDomValue(fieldId, value) {
      const normalized = value ?? "";
      const { root, input } = this.getDatepickerElements(fieldId);
      if (root) {
        root.value = normalized;
      }
      if (input) {
        input.value = normalized;
      }
    },
    setDateOfBirth(targetField, newValue){
      const normalizedValue = this.normalizeDateInput(newValue);
      this.setDatepickerDomValue(targetField, normalizedValue);
      if (Object.prototype.hasOwnProperty.call(this.$store.state, targetField)) {
        this.$store.state[targetField] = normalizedValue;
      }
      if (targetField === "traveller1_dob" && (this.$store.state.oldestTraveller_isPrimary === true || this.$store.state.numberOfTravellers === "1")) {
        this.$store.state.oldestTraveller_dob = normalizedValue;
      }
      if (targetField === "traveller2_dob" && this.$store.state.oldestTraveller_isPrimary === false) {
        this.$store.state.oldestTraveller_dob = normalizedValue;
      }

      const { root, input } = this.getDatepickerElements(targetField);
      if (root) {
        root.classList.remove("is-invalid");
        root.classList.add("is-valid");
      }
      if (input) {
        input.classList.remove("is-invalid");
        input.classList.add("is-valid");
      }
      const validationTarget = root ?? input;
      if (validationTarget && validateField(validationTarget, normalizedValue, validationRules())) {
        validateBirthDate(validationTarget, normalizedValue, this.$store.state.wantsMedical);
      }
      // Check if the Nav Proceed button should be updated.
      if(normalizedValue!==""){
        const isInvalid = (root && root.classList.contains("is-invalid")) || (input && input.classList.contains("is-invalid"));
        if(!isInvalid){
          const targets = [];
          for(let i=1; i<=10;i++){
            if(i<=parseInt(this.$store.state.numberOfTravellers || "0", 10)){
              const { input: travellerInput, root: travellerRoot } = this.getDatepickerElements("traveller"+i+"_dob");
              const navTarget = travellerInput ?? travellerRoot;
              if(navTarget){
                targets.push(navTarget);
              }
              if(targetField!=="traveller"+i+"_dob"){
                this.setDatepickerDomValue("traveller"+i+"_dob", this.$store.state["traveller"+i+"_dob"]);
              }
            }
          }
          updateNavProceed(targets);
        }
        else {
          document.getElementById("nav_next_enabled").classList.add("d-none");
          document.getElementById("nav_next_disabled").classList.remove("d-none");
        }
      }
      this.calculateOldestTraveller();
    },
    calculateOldestTraveller(){
      let oldestTraveller = 0;
      const numberOfTravellers = parseInt(this.$store.state.numberOfTravellers || "0", 10);
      const departureValue = this.normalizeDateInput(this.$store.state.departureDate) || this.$moment().format("MM/DD/YYYY");
      const departureMoment = this.$moment(departureValue, "MM/DD/YYYY", true);
      for(let i=1; i<=10;i++){
        if(i<=numberOfTravellers && departureMoment.isValid()) {
          const travellerDob = this.normalizeDateInput(this.$store.state["traveller"+i+"_dob"] || this.getDatepickerValue("traveller"+i+"_dob"));
          const dobMoment = this.$moment(travellerDob, "MM/DD/YYYY", true);
          if(dobMoment.isValid()) {
            const age = departureMoment.diff(dobMoment, "years", false);
            if(age>oldestTraveller) {
              oldestTraveller=age;
            }
          }
        }
      }
      if(oldestTraveller>0) {
        this.$store.commit("updateOldestTraveller", oldestTraveller);
      }
    },
    swapPrimaryApplicant(){
      const traveller1Value = this.normalizeDateInput(this.$store.state.traveller1_dob || this.getDatepickerValue("traveller1_dob"));
      const traveller2Value = this.normalizeDateInput(this.$store.state.traveller2_dob || this.getDatepickerValue("traveller2_dob"));
      this.setDateOfBirth("traveller1_dob", traveller2Value);
      this.setDateOfBirth("traveller2_dob", traveller1Value);
      if(this.$store.state.oldestTraveller_isPrimary===true){
        this.$store.state.oldestTraveller_isPrimary=false;
        this.formatOldestTraveller(false);
      } else {
        this.$store.state.oldestTraveller_isPrimary=true;        
        this.formatOldestTraveller(true);
      }

    },
    formatOldestTraveller(state=this.$store.state.oldestTraveller_isPrimary){
      const traveller1Elements = this.getDatepickerElements("traveller1_dob");
      const traveller2Elements = this.getDatepickerElements("traveller2_dob");
      const traveller1Control = traveller1Elements.input ?? traveller1Elements.root;
      const traveller2Control = traveller2Elements.input ?? traveller2Elements.root;
      if(state===true)
      {
        document.getElementById("isPrimaryApplicant").checked=true;
        if(this.$store.state.numberOfTravellers>1){
          document.getElementById("isPrimaryApplicant").style.display="block";
          document.getElementById("lbl_isPrimaryApplicant").style.display="block";        
        }
        else {
          document.getElementById("isPrimaryApplicant").style.display="none";
          document.getElementById("lbl_isPrimaryApplicant").style.display="none";  
        }

        if(traveller1Control){
         // traveller1Control.setAttribute("disabled","disabled");
          this.isDisabledPrimaryApplicant1 = true;
          
        }
        if(traveller2Control){
         // traveller2Control.removeAttribute("disabled");
           this.isDisabledPrimaryApplicant2 = false;
          
        }
        document.getElementById("isNotPrimaryApplicant").checked=false;
        document.getElementById("isNotPrimaryApplicant").style.display="none";
        document.getElementById("lbl_isNotPrimaryApplicant").style.display="none";
      } 
      else {
         document.getElementById("isPrimaryApplicant").checked=false;
        document.getElementById("isPrimaryApplicant").style.display="none";
        document.getElementById("lbl_isPrimaryApplicant").style.display="none";
        if(traveller1Control){
          //traveller1Control.removeAttribute("disabled");
          this.isDisabledPrimaryApplicant1 = false;
         
        }
        if(traveller2Control){
          //traveller2Control.setAttribute("disabled","disabled");
           this.isDisabledPrimaryApplicant2 = true;
        }
        document.getElementById("isNotPrimaryApplicant").checked=true;
        document.getElementById("isNotPrimaryApplicant").style.display="block";
        document.getElementById("lbl_isNotPrimaryApplicant").style.display="block";
      }
    },
    datePickerLanguageLookup() {
        const locale = getLocale();
        if(locale==="fr") {
          return "fr";
        }
        else {
          return "en-US";
        }
    }
  },
  mounted() {
    // Clear appended text from Quote page title;
    document.getElementById("stepTitleAppend").innerHTML="";
    
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Show/hide the traveller fields depending on # selected
    const rowList = document.getElementById("travellerSection").children;
    let rowsToShow = this.$store.state.numberOfTravellers;
    if (rowsToShow === "") {
      rowsToShow = 1;
    }
    for (let x = 0; x <= 9; x++) {
      if (x < rowsToShow) {
        
        rowList[x].classList.remove("d-none");
      } else {
        rowList[x].classList.add("d-none");
      }
    }

    // Manually add ARIA-REQUIRED tag for date time inputs
    for (let i = 1; i <= 10; i++) {
      const { input } = this.getDatepickerElements(`traveller${i}_dob`);
      if (input) {
        input.setAttribute("aria-describedby", `err_traveller${i}_dob`);
        input.setAttribute("aria-required", "true");
      }
    }

    // Check if Next button should be enabled or disabled.
    const targets = [];
    for (let i = 1; i <= 10; i++) {
      const { input, root } = this.getDatepickerElements(`traveller${i}_dob`);
      const navTarget = input ?? root;
      if (navTarget) {
        targets.push(navTarget);
      }
    }
    this.$nextTick( () => {
      updateNavProceed(targets);
      this.formatOldestTraveller();
      this.calculateOldestTraveller();
    });
  },
}
</script>
